import { Button } from '@mui/material';
import React from 'react';

interface Props {
    label: any;
    style: string;
    disabled: boolean | undefined;
    id: string;
    onClick?: (event?: any, other?: any) => void;
    type?: 'button' | 'submit';
    variant?: 'contained' | 'outlined' | 'text' | undefined ;
    size?: 'small';
    sx?: any;
}

const ButtonComponent: React.FC<Props> = (props: Props) => {
    return (
        <Button
            id={props.id}
            onClick={props.onClick}
            className={props.style + ' borderRadius1'}
            type={props.type || 'button'}
            disabled={props.disabled}
            style={{ boxShadow: 'none', fontSize:  props.size ? '14px' : '16px'}}
            variant={props.variant}
            sx={props.sx}
        >
            {props.label}
        </Button>
    )
}

export default ButtonComponent;